import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Button, Input, Modal } from 'antd';
import { toast } from 'react-toastify';

const SignatureVerificationModal = ({ open, close, name, verifierFunction }) => {
    const [activeInput, setActiveInput] = useState(0);
    const inputRefs = useRef([]);
    let length = 4;
    const inputs = Array.from({ length });
    const [inputValues, setInputValues] = useState(Array(inputs.length).fill(''));
    const handleInputChange = (e, index) => {
        const value = e.target.value;
        const updatedInputValues = [...inputValues];
        updatedInputValues[index] = value;
        setInputValues(updatedInputValues);

        // Move to the next input if the current input is not empty
        if (value !== '') {
            const nextInputIndex = Math.min(index + 1, inputs.length - 1);
            setActiveInput(nextInputIndex);
            inputRefs.current[nextInputIndex].focus();
        }
    };

    const verifyHandler = () => {
        if(inputValues[0]!=''){
            verifierFunction(inputValues.join(''));
            close();
        }else{
            toast.error("Please enter your last 4 digits of NRIC number");
        }
    }

    return (
        <div>
            <Modal
                centered
                footer={false}
                open={open}
            >
                <div className='p-5'>
                    <div className='flex items-center justify-center'>
                        <img src="/images/ohhto_logo.png" alt="logo" />
                    </div>
                    <div className='text-center mt-4'>
                        <p className='font-[700] text-[17px] text-black'>Hi, {name}</p>
                        <p className='font-[400] text-[13px] text-black'>Authentication is required before you can sign</p>
                        <p className='font-[400] text-[13px] text-black'>Enter last 4 characters of your ID eg. 123H</p>
                        <div className='mt-5 mb-5'>
                            <Fragment>
                                <Input.Group compact>
                                    {inputs.map((_, index) => (
                                        <Input
                                            key={index}
                                            maxLength={1}
                                            type="text"
                                            size="large"
                                            style={{ width: '40px', marginRight: '10px', textAlign: 'center', borderRadius: '6px' }}
                                            onChange={(e) => handleInputChange(e, index)}
                                            ref={(input) => (inputRefs.current[index] = input)}
                                            autoFocus={activeInput === index}
                                        />
                                    ))}
                                </Input.Group>
                                <Button onClick={verifyHandler} className='mt-[20px] w-[110px]' type='primary'>Verify</Button>
                            </Fragment>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default SignatureVerificationModal;